/**
 * TPClassSelector
 *
 * Compact class selector tab for DNV / ABS / LR.
 * Used in GenerateTPPage.
 */
import React from 'react'
import type { TPClass } from '@/lib/tpWorkbookParserClass'
import { useTranslation } from 'react-i18next'

const CLASSES: { id: TPClass; label: string; sub: string }[] = [
  { id: 'DNV', label: 'DNV',  sub: 'Cyber Secure' },
  { id: 'ABS', label: 'ABS',  sub: 'Cyber Resilience' },
  { id: 'LR',  label: 'LR',   sub: 'Cyber Resilience' },
]

interface TPClassSelectorProps {
  value: TPClass
  onChange: (cls: TPClass) => void
  disabled?: boolean
}

export const TPClassSelector: React.FC<TPClassSelectorProps> = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation()
  return <div>
    <p className="text-xs font-medium text-slate-600 dark:text-slate-400 mb-1.5">
      {t('generateTP.classSociety')} <span className="text-red-500">*</span>
    </p>
    <div className="flex gap-1.5">
      {CLASSES.map(cls => (
        <button
          key={cls.id}
          type="button"
          disabled={disabled}
          onClick={() => onChange(cls.id)}
          className={`flex-1 py-2 px-3 rounded-md border text-sm font-medium transition-colors disabled:opacity-40 disabled:cursor-not-allowed
            ${value === cls.id
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300'
              : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-400 hover:border-blue-300'
            }`}
        >
          <div className="font-semibold">{cls.label}</div>
          <div className="text-xs font-normal opacity-70">{cls.sub}</div>
        </button>
      ))}
    </div>
  </div>
}
